module.exports = __webpack_public_path__ + "img/J12870.bf2013ed.png";